import React from "react";
import FrontendLayout from "../FrontendLayout";
import Hero from "../front-components/Hero";
import { ORG } from "../../data/costant";

const Terms = () => {
  return (
    <FrontendLayout>
      <Hero title="Terms & Conditions" />
      <div className="container my-5 card">
        <div className="card-body">
          <section>
            <h6>Payment Plans</h6>
            <p>Payment plans for different types of trucks/transport vehicles shall be as listed on our site.</p>
          </section>

          <section>
            <h6>Advance Bookings</h6>
            <p>We accept advance bookings only if a token amount is paid in advance.</p>
          </section>

          <section>
            <h6>Fares and Charges</h6>
            <p>
              Our fares do not include out-of-pocket expenses including but not limited to:
            </p>
            <ul>
              <li>Labor charges</li>
              <li>Parking charges</li>
              <li>Night surcharge</li>
              <li>RTO challans</li>
              <li>RTO taxes</li>
              <li>Waiting time charges</li>
              <li>Any type of levy and other similar charges</li>
            </ul>
            <p>These expenses shall not be our liability and therefore shall be paid by you directly to the appropriate parties.</p>
          </section>

          <section>
            <h6>Non-Payment Policy</h6>
            <p>
              User authorizes and allows us to retain your consignments in case of any type of non-payment from your side.
              We may return your consignments only after due payment is received in our account.
            </p>
          </section>

          <section>
            <h6>Additional Charges Policy</h6>
            <ul>
              <li>You agree and acknowledge that you shall pay extra fare charges for industrial goods which require a lot of waiting time.</li>
              <li>You agree and acknowledge that you shall pay additional fare charges in case of availability crunch of the transport vehicle.</li>
              <li>Additional drop points or pickup points shall be considered additionally in fare charges.</li>
            </ul>
          </section>

          <section>
            <h6>Cancellation & Refund Policy</h6>
            <p>
              You agree and acknowledge that you believe in our success story and take our services with confidence. You agree and acknowledge before selecting services and making payment, you have evaluated our services completely as per your requirements. Also, you agree and acknowledge that there is a lot of work involved to achieve every milestone while offering services to you and therefore it shall be very difficult for us to provide any refund.
            </p>
            <p>
              Further, you agree and acknowledge to notify us for cancellation of a booking request. You shall provide us complete details of booking through our customer care interface. Booking amount is not refundable once we shared Vendor or Vehicle and driver details with you. In case your cancellation request is accepted, there shall be a cancellation fee and we may refund you the amount in 7 days’ time from the date of cancellation request acceptance.
            </p>
            <p>
              However, if a truck or any other transport vehicle is engaged to carry out transportation of the materials and has already been dispatched, your booking request shall not be canceled, and there shall not be any refund from our side. If the truck has reached the client location and there is a delay in loading, per-day waiting charges range from 1000 to 5000 depending on vehicle type. If the vehicle is not loaded and returned empty, the customer has to pay driver fuel charges.
            </p>
            <p>
              For any queries related to refund of the canceled booking, please contact us at:
            </p>
            <ul>
              <li>Phone : +91 {ORG.mobile}</li>
              <li>Email : <a href={`mailto:${ORG.email}`}>{ORG.email}</a></li>
            </ul>
            <p>
              Further, considering the same reasons, you agree and acknowledge that you shall not raise any dispute with payment repository/payment service providers for refunding the payment. In case if you raise any such disputes, you agree, acknowledge and allow us to instruct payment repository/payment service providers to credit payment in our account as per this clause.
            </p>
          </section>
        </div>
      </div>
    </FrontendLayout>
  );
};

export default Terms;
